import React from "react";

const TwitchLogin = () => {
  // console.log("twitch login page");
  return <div>Logging...</div>;
};

export default TwitchLogin;
